module.exports = __webpack_public_path__ + "img/dawn_thumb.42eeba65.jpg";